import React, { FC } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import background1 from '../../assets/images/contactbg.png'
import FormContact3D from '../../Components/FormContact3D';
import mailIcon from "../../assets/images/mailIcon.svg";
import phoneIcon from "../../assets/images/phoneIcon.svg";
import locationIcon from "../../assets/images/locationIcon.svg";
import map from "../../assets/images/map.png";
import FooterPublic3D from '../../Components/FooterPublic3D';
import { Button3D, } from '../../Components/Button3D';
import smallBgd2 from '../../assets/images/image3.png';
import { ImageBox } from '../../Components/ImageBox3D';
import { HeaderTitle, MediumHeaderTitle } from '../../Components/Text3D';
import HeaderComponent from '../../Components/HeaderComponents';

const WrapperContact = styled.div`
`;
const CustomUl = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: column;
    /* margin-left: 20%; */
`;
const Itemsli = styled.li`
display: flex;
margin: 5px;
`;

const ContactUsPageScreen: FC = () => {
    return (
        <>
            <WrapperContact>
                <HeaderComponent />
                <ImageBox bg={`url(${background1})`} height='400px'>
                    <HeaderTitle>Contact Us</HeaderTitle>
                </ImageBox>
                <Col span={18} offset={3}>
                    <Row style={{ marginTop: '5%' }}>
                        <Col md={{ span: 12 }} sm={{ span: 24 }}>
                            <CustomUl>
                                <li>
                                    <MediumHeaderTitle fontSize dark>Contact Details</MediumHeaderTitle>
                                </li>
                                <Itemsli>
                                    <span>
                                        <img src={locationIcon} alt="" />
                                    </span>
                                    <span style={{ marginLeft: '1rem' }}>Level 1/622-632 Harris St,<br /> Ultimo NSW 2007</span>
                                </Itemsli>
                                <Itemsli style={{ marginTop: '5px ' }}>
                                    <span>
                                        <img src={phoneIcon} alt="" />
                                    </span>
                                    <span style={{ marginLeft: '1rem' }}>+61 416198587</span>
                                </Itemsli>
                                <Itemsli>
                                    <span>
                                        <img src={mailIcon} alt="" />
                                    </span>
                                    <span style={{ marginLeft: '1rem' }}>help@3dprintit.net</span>
                                </Itemsli>
                                <li style={{ marginTop: '5%' }}>
                                    <MediumHeaderTitle dark>Find Us On Map</MediumHeaderTitle>
                                </li>
                                <li>
                                    <img src={map} alt="" />
                                </li>

                            </CustomUl>
                        </Col>
                        <Col md={{ span: 11, offset:1 }} sm={{ span: 24 }} style={{ display: 'flex', }}><FormContact3D /></Col>
                    </Row>
                </Col>
                <ImageBox bg={`url(${smallBgd2})`} height='300px' style={{ marginTop: '30px' }}>
                    <HeaderTitle>Start Printing</HeaderTitle>
                    <Button3D style={{ backgroundColor: '#1196DD', border: 'none', color: 'white' }}>GET STARTED</Button3D>
                </ImageBox>
                <FooterPublic3D />
            </WrapperContact>
        </>
    );
}
export default ContactUsPageScreen;